import {
    SIGN_OUT,
    SET_ROAD_TRIP_CARRIER_INFO,
    GET_ROAD_TRIP_CARRIER_COVERAGES,
    GET_ROAD_TRIP_CARRIER_COVERAGE_ORIGINS,
    GET_ROAD_TRIP_CARRIER_COVERAGE_DESTINATIONS,
    GET_ROAD_TRIP_CARRIER_COVERAGE_CARRIERS,
    SHOW_ROAD_TRIP_CARRIER_COVERAGE_DIALOG,
    HIDE_ROAD_TRIP_CARRIER_COVERAGE_DIALOG
} from "constants/ActionTypes";

const INIT_STATE = {
    roadTripCarrierCoverages: {
        data: [],
        count: 0
    },
    doShowCoverageDialog: false,
    originId: null,
    originAutocompleteOptions: [],
    destinationId: null,
    destinationAutocompleteOptions: [],
    carrierId: null,
    carrierAutocompleteOptions: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SIGN_OUT: {
            return INIT_STATE;
        }

        case SET_ROAD_TRIP_CARRIER_INFO: {
            return {
                ...state,
                originId: action.payload?.originId,
                destinationId: action.payload?.destinationId,
                carrierId: action.payload?.carrierId,
            };
        }

        case GET_ROAD_TRIP_CARRIER_COVERAGES: {
            return {
                ...state,
                doShowCoverageDialog: false,
                roadTripCarrierCoverages: action.payload,
            };
        }

        case GET_ROAD_TRIP_CARRIER_COVERAGE_ORIGINS: {
            const originList = action?.payload?.data ?? [];
            const sortedOriginList = originList.length
                ? [...originList].sort((a, b) => a.city.localeCompare(b.city))
                : []

            return {
                ...state,
                originAutocompleteOptions: sortedOriginList,
            }
        }

        case GET_ROAD_TRIP_CARRIER_COVERAGE_DESTINATIONS: {
            const destinationList = action?.payload?.data ?? [];
            const sortedDestinationList = destinationList.length
                ? [...destinationList].sort((a, b) => a.city.localeCompare(b.city))
                : []

            return {
                ...state,
                destinationAutocompleteOptions: sortedDestinationList,
            }
        }

        case GET_ROAD_TRIP_CARRIER_COVERAGE_CARRIERS: {
            const carriersList = action?.payload?.data ?? [];
            const filteredCarrierList = carriersList?.length
                ? [...carriersList].filter(option => option.label !== null && option.label !== undefined)
                : [];

            return {
                ...state,
                carrierAutocompleteOptions: filteredCarrierList,
            }
        }

        case SHOW_ROAD_TRIP_CARRIER_COVERAGE_DIALOG: {
            return {
                ...state,
                doShowCoverageDialog: true,
            }
        }

        case HIDE_ROAD_TRIP_CARRIER_COVERAGE_DIALOG: {
            return {
                ...state,
                doShowCoverageDialog: false,
            }
        }

        default: {
            return state;
        }
    }
}